const index = {
    5: [
        {
            title: 'Grundwissen',
            data: require('./5/Grundwissen/download.pdf')
        },
        {
            title: 'Aufgaben',
            data: require('./5/Aufgaben/download.pdf')
        },
        {
            title: 'Lösungen',
            data: require('./5/Loesungen/download.pdf')
        }
    ],
    6: [
        {
            title: 'Grundwissen',
            data: require('./6/Grundwissen/download.pdf')
        },
        {
            title: 'Aufgaben',
            data: require('./6/Aufgaben/download.pdf')
        },
        {
            title: 'Lösungen',
            data: require('./6/Loesungen/download.pdf')
        }
    ],
    7: [
        {
            title: 'Grundwissen',
            data: require('./7/Grundwissen/download.pdf')
        },
        {
            title: 'Aufgaben',
            data: require('./7/Aufgaben/download.pdf')
        },
        {
            title: 'Lösungen',
            data: require('./7/Loesungen/download.pdf')
        }
    ],
    8: [
        {
            title: 'Grundwissen',
            data: require('./8/Grundwissen/download.pdf')
        },
        {
            title: 'Aufgaben',
            data: require('./8/Aufgaben/download.pdf')
        },
        {
            title: 'Lösungen',
            data: require('./8/Loesungen/download.pdf')
        }
    ],
    9: [
        {
            title: 'Grundwissen',
            data: require('./9/Grundwissen/download.pdf')
        },
        {
            title: 'Aufgaben',
            data: require('./9/Aufgaben/download.pdf')
        },
        {
            title: 'Lösungen',
            data: require('./9/Loesungen/download.pdf')
        }
    ],
    10: [
        {
            title: 'Grundwissen',
            data: require('./10/Grundwissen/download.pdf')
        },
        {
            title: 'Aufgaben',
            data: require('./10/Aufgaben/download.pdf')
        },
        {
            title: 'Lösungen',
            data: require('./10/Loesungen/download.pdf')
        }
    ]
};

export const zip = require('./all.zip');
export default index;